import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAVER_BOOKING_URL } from '../data/siteConfig';

// Per-variant style table. Desktop is compact; mobile is larger and left-aligned.
const STYLES = {
  desktop: {
    base: { fontSize: '0.95rem', transition: 'color 0.2s' },
    button: {
      background: 'none', border: 'none', cursor: 'pointer', padding: 0,
      fontWeight: 400, color: 'var(--text-muted)',
    },
    link: { fontWeight: 400, color: 'var(--text-muted)' },
    activeLink: { color: 'var(--primary)', fontWeight: 600 },
    external: { color: 'var(--primary)', fontWeight: 600 },
  },
  mobile: {
    base: { fontSize: '1.1rem' },
    button: {
      background: 'none', border: 'none', cursor: 'pointer', padding: 0,
      color: 'var(--text)', fontWeight: 500, textAlign: 'left',
    },
    link: { fontWeight: 500, color: 'var(--text)' },
    activeLink: { color: 'var(--primary)' },
    external: { color: 'var(--primary)', fontWeight: 600 },
  },
};

// Single dispatcher for the 3 nav-link kinds: external / pricing-action / internal Link.
// Avoids the duplicate switch that NavBar.js previously had for desktop vs mobile.
export default function NavLinkItem({ link, variant, onPricingClick, onClose }) {
  const location = useLocation();
  const s = STYLES[variant];

  if (link.external) {
    // 예약(emphasize)만 강조 톤; 그 외 외부 링크(Blog 등)는 일반 메뉴 톤.
    const externalStyle = link.emphasize ? s.external : s.link;
    return (
      <a
        href={link.href || NAVER_BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}
        style={{ ...s.base, ...externalStyle }}
      >
        {link.label}
      </a>
    );
  }

  if (link.action === 'pricing') {
    return (
      <button
        type="button"
        onClick={() => { onPricingClick(); onClose?.(); }}
        style={{ ...s.base, ...s.button }}
      >
        {link.label}
      </button>
    );
  }

  // Active match: exact path OR (community) any /community/* sub-path.
  const active = link.to === '/community'
    ? location.pathname.startsWith('/community')
    : location.pathname === link.to;

  return (
    <Link to={link.to} style={{ ...s.base, ...s.link, ...(active ? s.activeLink : {}) }}>
      {link.label}
    </Link>
  );
}
